"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBffToJerichoItem = void 0;
function transformBffToJerichoItem(items, summary) {
    var currencyCode = summary.currencyCode;
    return items.map(function (item) {
        var catalogItemId = item.catalogItemId, externalId = item.externalId, priceDetails = item.priceDetails, catalogItemType = item.catalogItemType;
        var hasTrial = priceDetails.hasTrial, renewalPrice = priceDetails.renewalPrice, formattedSummary = priceDetails.formattedSummary, totalItemPrice = priceDetails.totalItemPrice;
        var formattedRenewalPrice = formattedSummary.renewalPrice;
        return {
            itemType: 'DIGITAL',
            price: totalItemPrice,
            renewalPrice: renewalPrice,
            itemId: catalogItemId,
            catalogItemType: catalogItemType,
            bundleItems: null,
            currencyName: currencyCode,
            externalId: externalId,
            billingDetails: {
                hasTrial: hasTrial,
                renewalPrice: renewalPrice,
                renewalPriceWithCurrencyFormat: formattedRenewalPrice,
            },
            priceDetails: priceDetails,
        };
    });
}
exports.transformBffToJerichoItem = transformBffToJerichoItem;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/transforms/transformBffToJerichoItem.js
// module id = 3374
// module chunks = 11